import React, { useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser } from "@fortawesome/pro-duotone-svg-icons";
import i18next from 'i18next';
import * as storage from '../../utils/storage';
import { formatDate } from '../../utils';

const useStyles = makeStyles((theme) => ({
    divRootGreetings: {
        height: '60px',
        borderRadius: '5px',
        float: 'left',
        marginTop: '10px',
        width: 'calc(100% - 80px)',
        display: 'table',
        textAlign: 'left',
        '& > span': {
            fontSize: '12px',
            paddingTop: '6px',
            display: 'table',
            marginLeft: '10px',
            color: '#333333',
        },
        '& > span:nth-child(2)': {
            marginLeft: '10px',
            marginTop: '-10px',
            fontSize: '20px',
            color: '#333333',
        }
    },
    divIcon: {
        textAlign: 'left',
        float: 'left',
        marginTop: '8px',
        '& > svg': {
            width: '50px',
            height: '50px',
            margin: '5px'
        }
    },
}));

function Greetings(props) {
    const classes = useStyles();

    useEffect(() => {
        showTimeGreetings();
    }, []);

    // We must use '/' to separete the date, otherwise the iOS will not work correctly
    const goodMorningDate = new Date(formatDate(new Date(), 'date', '/') + ' ' + '11:59');
    const goodAfternoonDate = new Date(formatDate(new Date(), 'date', '/') + ' ' + '17:59');
    const goodEveningDate = new Date(formatDate(new Date(), 'date', '/') + ' ' + '23:59');

    const showTimeGreetings = () => {
        const currentDate = new Date();

        if (currentDate <= goodMorningDate) {
            // Is morning
            return i18next.t('home:hello1');
        } else if (currentDate > goodMorningDate && currentDate < goodAfternoonDate) {
            // Is afternoon
            return i18next.t('home:hello2');
        } else {
            // Is Evening
            return i18next.t('home:hello3');
        }
    }

    return (
        <>
            <div className={classes.divIcon}>
                <FontAwesomeIcon icon={faCircleUser} style={{ color: 'var(--color1)' }}  />
            </div>
            <div className={classes.divRootGreetings}>
                <span>{showTimeGreetings()}</span>
                <span>{storage.getUserName()}</span>
            </div>
        </>
    );
}
export default withNamespaces(['home'], { wait: true })(Greetings);